import { createMapInstances, MapUI } from './mapUI';
import { Gamecloud } from '../../../../gamecloud';
import Axios from 'axios';

class Map extends Gamecloud {
    public constructor(private ui: MapUI) {
        super();
        this.fetch();
    }

    /**
     * Fetch data from API and trigger the ui render method
     */
    private fetch() {
        const ajax: string = this.ui.data().url;
        Axios.get(ajax).then((response) => {
            this.ui.render({img: ajax, id: "fmMap", label: "fmMapLable"});
        }).catch(() => {
            this.fetch();
        });
    }
}

export function initMap() {
    const instances: MapUI[] = createMapInstances();
    return instances.map((ui: MapUI) => {
        return new Map(ui);
    });
}
